import { render, staticRenderFns } from "./LoginNoticeModal.vue?vue&type=template&id=5d722164&scoped=true&"
import script from "./LoginNoticeModal.vue?vue&type=script&lang=js&"
export * from "./LoginNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginNoticeModal.vue?vue&type=style&index=0&id=5d722164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d722164",
  null
  
)

export default component.exports